import { CHARACTER_STAT } from '../model/consts';

export const statsLocaleMap: Record<CHARACTER_STAT, string> = {
  [CHARACTER_STAT.HEALTH]: 'characterTraitHealth',
  [CHARACTER_STAT.ATTACK]: 'characterTraitAttack',
  [CHARACTER_STAT.DEFENCE]: 'characterTraitDefense'
};
